/**
 * Fechas y horas siempre en hora de Costa Rica (donde está Kuanta Bridge), escritas como se
 * escriben en el idioma elegido.
 */
import { locale } from '../i18n/idioma';

const ZONA = 'America/Costa_Rica';
const LOCALE = () => locale();

export function hora(t: Date | string | number): string {
  return new Date(t).toLocaleTimeString(LOCALE(), { timeZone: ZONA, hour: '2-digit', minute: '2-digit', hour12: false });
}

export function dia(t: Date | string | number): string {
  return new Date(t).toLocaleDateString(LOCALE(), { timeZone: ZONA, day: 'numeric', month: 'short', year: 'numeric' });
}

/** "Sep 16, 2026 · 18:05", en hora de Costa Rica. */
export const cuando = (t: string | null | undefined) => (t ? `${dia(t)} · ${hora(t)}` : '—');

/** "3 min", "2 h 5 min", "4 d 6 h". Lo que lleva prendido, o hace cuánto se lo vio. */
export function duracion(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  if (s < 60) return `${s} s`;
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h >= 24) return `${Math.floor(h / 24)} d ${h % 24} h`;
  return h ? `${h} h ${m} min` : `${m} min`;
}

/** Cuánto pasó desde entonces: "4 min". */
export const desde = (t: string) => duracion(Date.now() - Date.parse(t));

/** Hace cuánto pasó algo: "4 min ago". Sin fecha = "never". */
export const hace = (t: string | null | undefined) => (t ? `${desde(t)} ago` : 'never');

/** Un número con sus decimales. */
export const coma = (n: number, decimales = 1) => n.toLocaleString(LOCALE(), { minimumFractionDigits: decimales, maximumFractionDigits: decimales });

/** Un porcentaje para mostrar; null cuando el appliance todavía no reportó nada. */
export const pc = (n: number | null | undefined) => (n === null || n === undefined ? '—' : `${coma(n, 0)} %`);

/** Entero con separador de miles. */
export const miles = (n: number | null | undefined) => (n === null || n === undefined ? '—' : n.toLocaleString(LOCALE()));

/**
 * Un día suelto (`2027-09-16`), dicho como se lee. No pasa por `dia`, que lo tomaría como
 * medianoche UTC y en Costa Rica lo mostraría como el día anterior.
 */
export function soloDia(v: string): string {
  const [a, m, d] = v.split('-').map(Number);
  if (!a || !m || !d) return v;
  // sin `timeZone`: un día no tiene hora, y convertirlo a la de Costa Rica lo corría al
  // día anterior a las 18:00 (que es lo que mostraba el panel)
  return new Date(a, m - 1, d).toLocaleDateString(LOCALE(), { day: 'numeric', month: 'short', year: 'numeric' });
}

/** El tamaño de un archivo grande, para decidir si uno lo baja ahora o más tarde. */
export function gigas(bytes: number): string {
  if (bytes >= 1e9) return `${(bytes / 1e9).toFixed(1)} GB`;
  if (bytes >= 1e6) return `${Math.round(bytes / 1e6)} MB`;
  return `${Math.max(1, Math.round(bytes / 1e3))} kB`;
}
